import { GiftProduct, GiftProductType } from '../../../models';

/**
 * Recompensa que tem local de troca a escolher.
 *
 * Ficam de fora:
 * - desconto no abastecimento: herda os locais do desconto vinculado;
 * - palpite, número da sorte e giro: não geram cupom resgatável em posto;
 * - recompensa em dinheiro: o cupom vale em qualquer local da rede que aceite cashback —
 *   o PDV o acha pelo `redeem_anywhere` e nunca consulta `gift_product_place`.
 *
 * A MESMA regra decide o que aparece no passo de locais e se o passo é obrigatório. Separada
 * daqui para as duas telas não divergirem: divergindo, ou o passo exige um local que não há
 * onde escolher, ou libera um produto que precisava de um.
 */
export const productNeedsRedemptionPlaces = (product: Partial<GiftProduct>): boolean => {
  if ((product.cashValue ?? null) !== null) { return false; }

  return product.type !== GiftProductType.FuelDiscount
    && product.type !== GiftProductType.PredictionTicket
    && product.type !== GiftProductType.DrawingNumber
    && product.type !== GiftProductType.SpinTicket;
};

/** Brinde em que nenhuma recompensa tem local a escolher — o passo inteiro é dispensável. */
export const everyProductSkipsPlaces = (products: Partial<GiftProduct>[] = []): boolean =>
  products.length > 0 && products.every(product => !productNeedsRedemptionPlaces(product));

/**
 * `productIndex` é a posição do produto no array do BRINDE, e a lista do passo de locais é
 * filtrada — as posições não coincidem. Procurar por posição pega o produto errado, ou
 * nenhum (foi o "Cannot read properties of undefined" ao adicionar local num brinde cujo
 * primeiro produto era a recompensa em dinheiro).
 */
export const findByProductIndex = <T extends { productIndex: number }>(
  configs: T[],
  productIndex: number,
): T | undefined => configs.find(config => config.productIndex === productIndex);
